<template>

	<component
        :is="visible"
        :stap="stap"
        :language="language">
    </component>

</template>

<script>

import Blok_1 from './blokken/blok_1';
import Blok_2 from './blokken/blok_2';
import Blok_3 from './blokken/blok_3';
import Blok_4 from './blokken/blok_4';
import Blok_5 from './blokken/blok_5';
import Blok_6 from './blokken/blok_6';
import Blok_7 from './blokken/blok_7';
import Blok_8 from './blokken/blok_8';

export default {
	name: 'Blokcontroller',
	props: ['stap', 'language'],
	data: function() {
		return {
			visible: null
		}
	},
	mounted: function() {
		this.visible = this.stap["Stap_naam"];
	},
	methods: {
		
	},
	components: {
		Blok_1,
		Blok_2,
		Blok_3,
		Blok_4,
		Blok_5,
		Blok_6,
		Blok_7,
		Blok_8
	}
}
</script>
